export default __webpack_public_path__ + "static/media/client-16.612c5845.webp";